// 同步请求的协议头
export const syncRequestHeader = 'sync.request.';
// 异步请求的协议图
export const asyncRequestHeader = 'async.request.';
// 异步回复协议头
export const responseHeader = 'response.';
// 与安卓双向消息订阅都共用的协议头：
// 1. web向android订阅：在事件机制中订阅事件，并在接收到安卓信息时发布事件
// 2. android向web订阅：向安卓发布事件
export const subscribeMessageHeader = 'sub.';

export const successReciveMessageReturnString = 'success';

export const JSBridgeCallbackName = 'JSBridgeReceiveMessage';
